import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import moment from 'moment';

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';

import ReactTable from "react-table";
import "react-table/react-table.css";
const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };




class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
            correo:'',
            cc:[],
            cc_text:'',
            factura:[],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.delete = this.delete.bind(this);
        this.push = this.push.bind(this);
	}
    push(){
        let {cc,cc_text} = this.state;
       if(cc_text.length>0){

         cc.unshift({
          correo : cc_text,
            });
        this.setState({
          cc : cc,
          cc_text:'',
        });

       }
       

    }
    delete(evt,index){
        let {cc} = this.state;  

        cc.splice(index,1);
        this.setState({
          cc : cc,
        });
    }
    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        this.setState({
           [name] : value,
        });
    }

    componentDidMount()
    {
    let cliente=this.props.cliente;
    let factura=this.props.factura;
    // console.log('modal correo factura--->',factura);
    // console.log('cliente--->',cliente);
      let self=this;
      api().get('/cliente/'+cliente)
      .then(function(response)
      {
        if(response.status === 200)
        {
            // console.log('cliente--->',response.data);
            let correo =response.data.correo

          api().get('/searchInvoice/'+factura)
          .then(function(response)
          {
            if(response.status === 200)
            {
                  // console.log('factura--->',response.data.factura);
                  self.setState({
                    correo : correo,
                    factura: response.data.factura,
                  });          
            }
          });         
        }
      });   
       
        ////console.log(this.state.ticketVenta)
    }

    

    

    handleSelectChange(select, name) {

        const value = select === null ? null : select.value;
        this.setState({ 
                [name]: value,
        });
    }

    

	handleSubmit(evt)
	{
		evt.preventDefault();
        let {cc,correo,factura} = this.state;
        
        cc.unshift({
          correo : correo,
            });
        // correos.correo=correo;
        let correos={
            lista:cc,
            factura: factura,

        };
        console.log('correos------>',correos);
        let self =this;

        this.props.enviar_factura(correos, (data) => {
          self.props.alerta({
            mensaje:"Factura Enviada  Correctamente",
            tipo:"success",
            creacion:moment().format('Y-MM-DD H:m:s'),
          });
          self.props.toggle();
      });

	}

	render()
	{
       // console.log('lista de correos--->',this.state.cc);
       let {factura}=this.state;
		
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} style={{marginTop: '0'}} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>Correo</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-md-12"> 
                                    <div className="form-group">
                                      <label className>Factura: {factura.factura_consecutivo}</label>
                                  </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-5"> 
                                <div className="form-group">
                                    <Label>Correo *</Label>
                                    <Input
                                    className='texto_normal'
                                    placeholder=""
                                    type="text"
                                    name="correo"
                                    maxLength={70}
                                    value={this.state.correo}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                              </div>
                            <div className="col-md-5"> 
                                <div className="form-group">
                                    <label className>Copia a:</label>
                                    <Input
                                    className='texto_normal'
                                    placeholder=""
                                    type="text"
                                    name="cc_text"
                                    maxLength={70}
                                    value={this.state.cc_text}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <Button color="primary" className="" 
                                    style={{marginTop: '2rem'}} onClick={this.push}>
                                        Agregar
                                    </Button>
                                </div>
                            </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12"> 
                            <ReactTable
                              data      = {this.state.cc}
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:100,minWidth:100,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="danger" 
                                                 onClick={(evt)=>this.delete(evt, row.index)}>
                                                    X
                                                </Button> 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Correo', accessor: 'correo'},
                                                     
                              
                              ]}
                              filterable 
                             pageSizeOptions= {[5]}  defaultPageSize={5} 
                               defaultFilterMethod={filterCaseInsensitive}
                            />        
                        </div>
                    </div>
                    
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.ticket.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			Enviar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/facturarTicket/ModalCorreo.js